export default __webpack_public_path__ + "static/photo-2e3e6c54fb6f9eaaf08ea8f0d092ec33.webp";